import { render, staticRenderFns } from "./VCopy.vue?vue&type=template&id=313a0567&"
import script from "./VCopy.vue?vue&type=script&lang=ts&"
export * from "./VCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313a0567')) {
      api.createRecord('313a0567', component.options)
    } else {
      api.reload('313a0567', component.options)
    }
    module.hot.accept("./VCopy.vue?vue&type=template&id=313a0567&", function () {
      api.rerender('313a0567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VCopy/VCopy.vue"
export default component.exports